import { BlockConfig, zeroIOPS, OperationTypes, ContentTypes, QUEUE_MAX_STORAGE } from "../block-base";
import { BlockTypes } from "../block-types";

export const queueConfig: BlockConfig = {
  displayName: "Queue",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LOAD_BALANCER,
    BlockTypes.APP_SERVER,
    BlockTypes.LAMBDA,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.LAMBDA,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: {
    total: QUEUE_MAX_STORAGE, // High input capacity to accept bursts
    byOperationType: {
      [`${OperationTypes.WRITE}`]: {
        total: QUEUE_MAX_STORAGE,
        byContentType: { [`${ContentTypes.DYNAMIC}`]: QUEUE_MAX_STORAGE },
      },
    },
  },
  processingCapacity: zeroIOPS(), // Delegates processing logic to the game loop
  purchasePrice: 200,
  sellPrice: 100,
  costPerCycle: 0.5,
  outputConnectorLimits: {},
};
